import { render, staticRenderFns } from "./IdProofFrontBack.vue?vue&type=template&id=33157144"
import script from "./IdProofFrontBack.vue?vue&type=script&lang=js"
export * from "./IdProofFrontBack.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports